module.exports = __webpack_public_path__ + "media/images/top/rank-platinum-1e7db0b8e1d12902e33f2ef989b17beb.webp";